export const MAX_MONTHLY_AI_QUERIES = 50;
